import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { TextNodeType } from '@mwe/models';
import { NgClass } from '@angular/common';
import { ButtonComponent } from '../buttons/button/button.component';
import { HeadlineComponent } from '../headline/headline.component';
import { StaticContentService } from '@mwe/services';
import { SafeHtmlPipe } from '@mwe/ui/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { HeadlineService } from '../headline/headline.service';

const IMG_SUBPATH = 'empty-state/';

type EmptyStateImage = 'add-products.svg' | 'box.svg' | 'connection-lost.svg' | 'rotate.svg';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mwe-empty-state',
  templateUrl: './empty-state.component.html',
  imports: [ButtonComponent, HeadlineComponent, SafeHtmlPipe, TranslatePipe, NgClass],
  providers: [HeadlineService],
})
export class EmptyStateComponent {
  staticImage = input.required<EmptyStateImage>();
  headlineText = input.required<string>();
  headlineNodeType = input<TextNodeType>('h2');
  headline2Text = input<string>();
  headline2NodeType = input<TextNodeType>('h3');
  messageKeys = input<string[]>();
  placeholderMap = input<Map<string, string>>();
  isVisible = signal(true);
  ctaLabel = input<string>();
  /** @todo refactor the button handling */
  ctaShowSpinner = input<boolean>(false);
  cta2Label = input<string>(null);
  cta2ShowSpinner = input<boolean>(false);
  alignment = input<'left' | 'center' | 'right'>('center');
  alignmentClass = computed<string>(() => {
    switch (this.alignment()) {
      case 'left':
        return 'text-start';
      case 'center':
        return 'text-center';
      case 'right':
        return 'text-end';
    }
  });
  rowAlignmentClass = computed<string>(() => {
    switch (this.alignment()) {
      case 'left':
        return 'justify-content-start';
      case 'center':
        return 'justify-content-center';
      case 'right':
        return 'justify-content-end';
    }
  });

  onCtaClick = output();
  onCta2Click = output();

  private staticContentService = inject(StaticContentService);

  staticImagePath = computed(() => {
    return this.staticContentService.getImagePath() + IMG_SUBPATH + this.staticImage();
  });

  translateValues = computed<{ [key: string]: string | number }>(() => {
    if (!this.placeholderMap()) return {};
    return [...this.placeholderMap().entries()]?.reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: value,
      }),
      {},
    );
  });
}
